import { useParams } from "react-router-dom";
import { AdminPageShell } from "@/components/shared/admin-page-shell";
import { UserFormPage } from "@/features/users/components/UserFormPage";
import { useUser } from "@/features/users/hooks/useUsersQueries";

export default function UsersEditPage() {
  const { id = "" } = useParams();
  const { data: user, isLoading, error } = useUser(id);

  return (
    <AdminPageShell
      title="تعديل مستخدم"
      description="تعديل بيانات المستخدم والصلاحيات المرتبطة به"
      isLoading={isLoading}
      error={error}
    >
      {user && <UserFormPage user={user} />}
    </AdminPageShell>
  );
}
